function _hotjar() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 1833226, hjsv: 6 };
    const head = o.getElementsByTagName("head")[0];
    const script = o.createElement("script");
    script.async = 1;
    script.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    head.appendChild(script);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

export default function loadServices() {
  _hotjar();
}
